import { motion } from "framer-motion";

export const AboutTimeline = ({ content }) => {
  const section = content.aboutSection;
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32">
      <div className="absolute inset-0 grid-bg opacity-18" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="section-kicker justify-center mb-4">{section.kicker}</span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl">
            {section.title}
          </h2>
          <p className="mt-5 text-white/60 leading-relaxed">
            {section.description}
          </p>
        </motion.div>

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-brand/60 via-brand/30 to-transparent sm:-translate-x-px" aria-hidden="true" />
          <div className="space-y-8">
            {section.timeline.map((t, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={t.year}
                  initial={{ opacity: 0, x: left ? -30 : 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5 }}
                  data-testid={`timeline-${t.year}`}
                  className={`relative pl-12 sm:pl-0 sm:w-1/2 ${
                    left ? "sm:pr-12 sm:text-right" : "sm:ml-auto sm:pl-12"
                  }`}
                >
                  <span
                    className={`absolute top-1.5 w-4 h-4 rounded-full bg-brand glow-brand animate-pulse-glow left-[9px] sm:left-auto ${
                      left ? "sm:-right-2" : "sm:-left-2"
                    }`}
                    aria-hidden="true"
                  />
                  <div className="glass rounded-lg p-5">
                    <div className="font-display font-bold text-2xl text-brand">{t.year}</div>
                    <p className="mt-1.5 text-sm text-white/65 leading-relaxed">{t.text}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-5 mt-20">
          {section.highlights.map((h) => (
            <motion.div
              key={h.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="glass rounded-lg p-7 text-center"
            >
              <div className="font-display font-bold text-2xl text-brand glow-text">{h.value}</div>
              <div className="text-sm font-semibold mt-2">{h.label}</div>
              <p className="text-xs text-white/55 mt-2 leading-relaxed">{h.desc}</p>
            </motion.div>
          ))}
        </div>

        <p className="text-center text-white/50 text-sm mt-10 max-w-2xl mx-auto">
          {section.visionPrefix} <span className="text-brand">"{section.vision1}"</span>{" "}
          and <span className="text-brand">"{section.vision2}"</span>
        </p>
      </div>
    </section>
  );
};

export default AboutTimeline;
